module.exports = __webpack_public_path__ + "img/front_skirt_length_asymmetric.6a0a239c.png";